/**
 * Handles color swatch clicks on product grid cards (card-product-generic.liquid).
 * Uses a single delegated listener instead of per-card bindings so it stays
 * cheap on collection pages that render many cards at once.
 */
(function () {
  function setActiveSwatch(swatchList, swatch) {
    swatchList.querySelectorAll('.card-swatch').forEach((el) => {
      const isActive = el === swatch;
      el.classList.toggle('active', isActive);
      el.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function swapImage(img, src, srcset, alt) {
    if (!img || !src) return;

    img.classList.add('is-swatching');

    const finish = () => img.classList.remove('is-swatching');
    img.addEventListener('load', finish, { once: true });
    img.addEventListener('error', finish, { once: true });
    // Fallback in case neither event fires (e.g. cached image edge cases).
    setTimeout(finish, 400);

    img.src = src;
    if (srcset) img.srcset = srcset;
    if (alt) img.alt = alt;
  }

  function updateImage(card, swatch) {
    const primaryImg = card.querySelector('.product-link-img img.card-product-img');
    swapImage(primaryImg, swatch.dataset.variantSrc, swatch.dataset.variantSrcset, swatch.dataset.variantAlt);

    // Hover image: only swap it if this color has a second matching photo —
    // otherwise leave the card's default secondary image in place.
    const hoverSrc = swatch.dataset.variantHoverSrc;
    if (hoverSrc) {
      const hoverImg = card.querySelector('.product-link-img img.card-product-secondimg');
      swapImage(hoverImg, hoverSrc, swatch.dataset.variantHoverSrcset, swatch.dataset.variantAlt);
    }
  }

  function updatePrice(card, swatch) {
    const priceEl = card.querySelector('[data-currentprice]');
    if (priceEl && swatch.dataset.variantPrice) {
      priceEl.textContent = swatch.dataset.variantPrice;
    }

    let compareEl = card.querySelector('[data-compareprice]');
    const comparePrice = swatch.dataset.variantComparePrice;

    if (comparePrice) {
      if (!compareEl && priceEl) {
        compareEl = document.createElement('s');
        compareEl.className = 'price money';
        compareEl.setAttribute('data-compareprice', '');
        priceEl.insertAdjacentElement('afterend', compareEl);
      }
      if (compareEl) compareEl.textContent = comparePrice;
    } else if (compareEl) {
      compareEl.remove();
    }
  }

  function updateVariant(card, swatch) {
    const variantId = swatch.dataset.variantId;
    const available = swatch.dataset.variantAvailable === 'true';
    const variantUrl = swatch.dataset.variantUrl;

    const hiddenInput = card.querySelector('.product-variant-id');
    if (hiddenInput) {
      hiddenInput.value = variantId;
      hiddenInput.disabled = !available;

      const submitButton = card.querySelector('.card-add-to-bag');
      if (submitButton) {
        submitButton.disabled = !available;
        const label = submitButton.querySelector('span:not(.sold-out-message)');
        const soldOut = submitButton.querySelector('.sold-out-message');
        if (label) label.classList.toggle('hidden', !available);
        if (soldOut) soldOut.classList.toggle('hidden', available);
      }
    }

    // Multi-variant products use a quick-add modal instead of the inline form;
    // point it at the selected variant so it opens pre-selected.
    const modalOpenerButton = card.querySelector('[data-product-url]');
    if (modalOpenerButton && variantUrl) {
      modalOpenerButton.setAttribute('data-product-url', variantUrl);
    }

    if (variantUrl) {
      card.querySelectorAll('.product-link-img, .card-product-title a').forEach((link) => {
        link.setAttribute('href', variantUrl);
      });
    }
  }

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.card-swatch');
    if (!swatch || !swatch.dataset.variantId) return;

    const swatchList = swatch.closest('.card-swatches');
    const card = swatch.closest('.card-product');
    if (!swatchList || !card) return;

    setActiveSwatch(swatchList, swatch);
    updateImage(card, swatch);
    updatePrice(card, swatch);
    updateVariant(card, swatch);
  });
})();
